module.exports = __webpack_public_path__ + "static/media/Schermafbeelding 2019-01-07 om 09.58.26.7fd4e632.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/endtest/assets/Schermafbeelding 2019-01-07 om 09.58.26.svg
// module id = 782
// module chunks = 0